import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.scss']
})
export class SkillsComponent implements OnInit {

  constructor() { }

  frontend: boolean = true;
  backend: boolean = false;
  designer: boolean = false;

  ngOnInit(): void {
  }

  onClickSkillFrontend() {
    this.frontend = !this.frontend;
  }

  onClickSkillBackend() {
    this.backend = !this.backend;
  }

  onClickSkillDesigner() {
    this.designer = !this.designer;
  }

}
